// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/background.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-family: 'Inter';
}

/* Full-screen wrapper */
.report-dashboard {
  width: 100%;
  height: 100vh;
  /* exactly full screen */
  background: var(--Neutral-50, #F8FAFC);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center bottom;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  /* no scrollbars */
}

/* Top logo + tagline */
.startLogoContainer {
  width: 100%;
  text-align: center;
  padding-top: 24px;
  /* small fixed spacing */
}

.logoContainer {
  margin-block: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 7px;
}

.logo {
  width: 53px;
  height: 48px;
}

.companyName {
  color: #094B38;
  -webkit-text-stroke-width: 0.21px;
  -webkit-text-stroke-color: #042A20;
  font-family: "Work Sans", sans-serif;
  font-size: 40px;
  font-weight: 500;
  letter-spacing: -2px;
}

.tagline {
  color: #334155;
  text-align: center;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-style: italic;
  font-weight: 500;
  margin-top: 6px;
}

/* Center section with title + button */
.mainStart {
  flex: 1 1;
  /* take all remaining height */
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* vertically centered */
  text-align: center;
  padding: 0 16px 32px;
  box-sizing: border-box;
}

/* Titles */
.startTitle {
  color: #094B38;
  font-family: "Work Sans", sans-serif;
  font-size: 40px;
  font-weight: 500;
  letter-spacing: -2px;
  margin: 0 0 8px 0;
  /* no vh padding */
}

.subStartTitle {
  color: #334155;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 32px 0;
}

/* Start button */
.startButton {
  width: 30%;
  max-width: 320px;
  min-width: 220px;
  height: 48px;
  border-radius: 4px;
  border: 0.5px solid #0A5B42;
  background: linear-gradient(180deg, #0C8F63 0%, #0A7253 103.57%);
  box-shadow: 0px 8px 8px rgba(50, 50, 71, 0.08),
    0px 8px 16px rgba(50, 50, 71, 0.06);
  color: #F8FAFC;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.startButton:hover {
  background: linear-gradient(180deg, #075a3e 0%, #053e2d 103.57%);
}

.copyright-section {
  position: absolute;
  bottom: 2vh;
  width: 100%;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  color: #475569;
}

.copyright-link {
  color: #0C8F63;
  cursor: pointer;
  text-decoration: underline;
}

.copyright-link:hover {
  color: #065f46;
}


/* Mobile tweaks */
@media (max-width: 768px) {
  .companyName {
    font-size: 32px;
  }

  .startTitle {
    font-size: 32px;
  }

  .startButton {
    width: 60%;
  }
}

@media (max-width: 480px) {
  .companyName {
    font-size: 28px;
  }

  .startTitle {
    font-size: 26px;
  }

  .subStartTitle {
    font-size: 14px;
  }

  .tagline {
    font-size: 12px;
  }

  .startButton {
    width: 70%;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/StartScreen/StartScreen.css"],"names":[],"mappings":"AAAA,UAAU;AACV;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,sCAAsC;EACtC,yDAAqD;EACrD,4BAA4B;EAC5B,sBAAsB;EACtB,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,kCAAkC;EAClC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,SAAO;EACP,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,gEAAgE;EAChE;uCACqC;EACrC,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;;AAGA,kBAAkB;AAClB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* Reset */\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  font-family: 'Inter';\n}\n\n/* Full-screen wrapper */\n.report-dashboard {\n  width: 100%;\n  height: 100vh;\n  /* exactly full screen */\n  background: var(--Neutral-50, #F8FAFC);\n  background-image: url(../../../assets/background.svg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center bottom;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow: hidden;\n  /* no scrollbars */\n}\n\n/* Top logo + tagline */\n.startLogoContainer {\n  width: 100%;\n  text-align: center;\n  padding-top: 24px;\n  /* small fixed spacing */\n}\n\n.logoContainer {\n  margin-block: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 7px;\n}\n\n.logo {\n  width: 53px;\n  height: 48px;\n}\n\n.companyName {\n  color: #094B38;\n  -webkit-text-stroke-width: 0.21px;\n  -webkit-text-stroke-color: #042A20;\n  font-family: \"Work Sans\", sans-serif;\n  font-size: 40px;\n  font-weight: 500;\n  letter-spacing: -2px;\n}\n\n.tagline {\n  color: #334155;\n  text-align: center;\n  font-family: Inter, sans-serif;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 500;\n  margin-top: 6px;\n}\n\n/* Center section with title + button */\n.mainStart {\n  flex: 1;\n  /* take all remaining height */\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  /* vertically centered */\n  text-align: center;\n  padding: 0 16px 32px;\n  box-sizing: border-box;\n}\n\n/* Titles */\n.startTitle {\n  color: #094B38;\n  font-family: \"Work Sans\", sans-serif;\n  font-size: 40px;\n  font-weight: 500;\n  letter-spacing: -2px;\n  margin: 0 0 8px 0;\n  /* no vh padding */\n}\n\n.subStartTitle {\n  color: #334155;\n  font-family: Inter, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0 0 32px 0;\n}\n\n/* Start button */\n.startButton {\n  width: 30%;\n  max-width: 320px;\n  min-width: 220px;\n  height: 48px;\n  border-radius: 4px;\n  border: 0.5px solid #0A5B42;\n  background: linear-gradient(180deg, #0C8F63 0%, #0A7253 103.57%);\n  box-shadow: 0px 8px 8px rgba(50, 50, 71, 0.08),\n    0px 8px 16px rgba(50, 50, 71, 0.06);\n  color: #F8FAFC;\n  text-align: center;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.startButton:hover {\n  background: linear-gradient(180deg, #075a3e 0%, #053e2d 103.57%);\n}\n\n.copyright-section {\n  position: absolute;\n  bottom: 2vh;\n  width: 100%;\n  text-align: center;\n  font-family: Inter;\n  font-size: 14px;\n  color: #475569;\n}\n\n.copyright-link {\n  color: #0C8F63;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.copyright-link:hover {\n  color: #065f46;\n}\n\n\n/* Mobile tweaks */\n@media (max-width: 768px) {\n  .companyName {\n    font-size: 32px;\n  }\n\n  .startTitle {\n    font-size: 32px;\n  }\n\n  .startButton {\n    width: 60%;\n  }\n}\n\n@media (max-width: 480px) {\n  .companyName {\n    font-size: 28px;\n  }\n\n  .startTitle {\n    font-size: 26px;\n  }\n\n  .subStartTitle {\n    font-size: 14px;\n  }\n\n  .tagline {\n    font-size: 12px;\n  }\n\n  .startButton {\n    width: 70%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
